/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { RunTestJobRequest } from './runTestJobRequest';
import type { RunBulkJobRequest } from './runBulkJobRequest';
import type { RunAutogradeJobRequest } from './runAutogradeJobRequest';
import type { RunResourceProcessJobRequest } from './runResourceProcessJobRequest';
import type { RunMeetingNotificationsEnsureJobRequest } from './runMeetingNotificationsEnsureJobRequest';
import type { RunMeetingNotificationsCleanupJobRequest } from './runMeetingNotificationsCleanupJobRequest';
import type { RunMeetingsNoShowFinalizeJobRequest } from './runMeetingsNoShowFinalizeJobRequest';
import type { RunMeetingsTeamsOralUnwindJobRequest } from './runMeetingsTeamsOralUnwindJobRequest';
import type { RunMeetingsLivekitOralUnwindJobRequest } from './runMeetingsLivekitOralUnwindJobRequest';
import type { RunMeetingsEmptySlotsCancelJobRequest } from './runMeetingsEmptySlotsCancelJobRequest';
import type { RunMeetingsEventCompletionFinalizeJobRequest } from './runMeetingsEventCompletionFinalizeJobRequest';
import type { RunTeamsHealthcheckJobRequest } from './runTeamsHealthcheckJobRequest';
import type { RunEventPlanningCheckJobRequest } from './runEventPlanningCheckJobRequest';
import type { RunLecturerBriefingJobRequest } from './runLecturerBriefingJobRequest';
import type { RunEventParticipantReminderJobRequest } from './runEventParticipantReminderJobRequest';
import type { RunLecturerSessionReminderJobRequest } from './runLecturerSessionReminderJobRequest';
import type { RunTrialUserGarbageCollectionJobRequest } from './runTrialUserGarbageCollectionJobRequest';
import type { RunUpdateLifecycleStatesJobRequest } from './runUpdateLifecycleStatesJobRequest';
import type { RunEvaluationMonitoringJobRequest } from './runEvaluationMonitoringJobRequest';
import type { RunProcessingReconcileJobRequest } from './runProcessingReconcileJobRequest';
import type { RunOralExamTranscribeJobRequest } from './runOralExamTranscribeJobRequest';
import type { RunOralExamEgressGuardReconcileJobRequest } from './runOralExamEgressGuardReconcileJobRequest';
import type { RunResourceProcessingReconcileJobRequest } from './runResourceProcessingReconcileJobRequest';
import type { RunWorkingModeApplyJobRequest } from './runWorkingModeApplyJobRequest';
import type { RunScheduledChangesTickJobRequest } from './runScheduledChangesTickJobRequest';
import type { RunScheduledChangeGenerateJobRequest } from './runScheduledChangeGenerateJobRequest';

export type RunJobInEngineBody =
  | RunTestJobRequest
  | RunBulkJobRequest
  | RunAutogradeJobRequest
  | RunResourceProcessJobRequest
  | RunMeetingNotificationsEnsureJobRequest
  | RunMeetingNotificationsCleanupJobRequest
  | RunMeetingsNoShowFinalizeJobRequest
  | RunMeetingsTeamsOralUnwindJobRequest
  | RunMeetingsLivekitOralUnwindJobRequest
  | RunMeetingsEmptySlotsCancelJobRequest
  | RunMeetingsEventCompletionFinalizeJobRequest
  | RunTeamsHealthcheckJobRequest
  | RunEventPlanningCheckJobRequest
  | RunLecturerBriefingJobRequest
  | RunEventParticipantReminderJobRequest
  | RunLecturerSessionReminderJobRequest
  | RunTrialUserGarbageCollectionJobRequest
  | RunUpdateLifecycleStatesJobRequest
  | RunEvaluationMonitoringJobRequest
  | RunProcessingReconcileJobRequest
  | RunOralExamTranscribeJobRequest
  | RunOralExamEgressGuardReconcileJobRequest
  | RunResourceProcessingReconcileJobRequest
  | RunWorkingModeApplyJobRequest
  | RunScheduledChangesTickJobRequest
  | RunScheduledChangeGenerateJobRequest;
